// System Global Variable
//----------------------------------------
export const PAGE_SIZE = 20;    // paging size
export const EXCEL_LINES = 5000;    // excel file lines
export const DETAIL_HISTORY_DUR = 14;   // duration of detailed status history
export const CONTROL_HISTORY_DUR = 30;   // duration of control history
export const CHART_DUR = 7; // chart display duration
export const NumOfGroup = 100;  // max of group
export const NumOfBsd = 1000;  // max of Bsd
export const SmsSender1 = '0538156419';  // SMS 발신번호 1
export const SmsSender2 = '01037926735';  // SMS 발신번호 2
export const NumOfSmsTel = 5;   // 한 장치당 SMS 수신번호, 최대 5개까지만

